import React, {useEffect, useRef, useState} from 'react';
import {View, FlatList, Platform, useWindowDimensions} from 'react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

import Button from '../../components/elements/Button';
import OnBoardingCard from '../../components/modules/OnBoardingCard';
import onBoardingData from '../../assets/data/onBoardingData';
import {BUTTON_TYPES} from '../../utils/Constants';
import {useTheme} from '../../theme';
import styles from './styles';
import {tID} from '../../utils/TestIdHelper';
import {DLog} from '../../utils/HelperMethods';

const OnBoardingExperience = ({navigation, route}) => {
  const {colors} = useTheme();
  //this ref is used for scrolling to indexes, only in web
  const flatListRef = useRef(null);
  const {width} = useWindowDimensions();
  const insets = useSafeAreaInsets();
  const [animationIndex, setAnimationIndex] = useState(1);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (Platform.OS === 'web') {
        //animation is only for web, remove this line to get it working in mobile
        flatListRef.current.scrollToIndex({
          animated: true,
          index: animationIndex,
        });
        setAnimationIndex((animationIndex + 1) % 6); //modding by 6 so we get back to first slide
      }
    }, 5000); //works every 5 seconds
    return () => {
      clearTimeout(timer);
    };
  }, [animationIndex]);

  const renderCard = (
    {item}, //render function used by flatlist
  ) => <OnBoardingCard data={item} />;

  return (
    <View
      style={styles.mainView}
      testID={tID('OnBoardingExperience-View-Main')}>
      <View
        style={styles.flex1}
        testID={tID('OnBoardingExperience-View-FlatListContainer')}>
        <FlatList
          ref={flatListRef}
          onScrollToIndexFailed={data =>
            DLog('Failed with the following data', data)
          }
          getItemLayout={(data, index) => ({
            //this is necessary for the ability to scroll. It puts placeholder for non-rendered items
            length: Platform.OS === 'web' ? width / 2 : width,
            offset: Platform.OS === 'web' ? (index * width) / 2 : index * width,
            index,
          })}
          horizontal={true}
          data={onBoardingData}
          renderItem={renderCard}
          keyExtractor={item => item.image1}
          pagingEnabled={true}
          showsHorizontalScrollIndicator={false}
          testID={tID('OnBoardingExperience-FlatList-OnBoardingSlideShow')}
        />
      </View>

      {Platform.OS != 'web' && (
        <View
          style={[
            styles.buttonsContainer,
            {paddingBottom: Math.max(16, insets.bottom + 16)},
          ]}
          testID={tID('OnBoardingExperience-View-ButtonsContainer')}>
          <Button
            style={styles.leftButton}
            onPress={() =>
              navigation.navigate('SignIn', {
                skipAutoFaceId: route?.params?.skipAutoFaceId,
              })
            }
            title={'Sign In'}
            testID={tID('OnBoardingExperience-Button-SignIn')}
          />
          <Button
            style={styles.rightButton}
            onPress={() => navigation.navigate('SubmitEmployerId')}
            title={'Register Now'}
            buttonType={BUTTON_TYPES.Filled}
            titleColor={colors.textOnAccent}
            testID={tID('OnBoardingExperience-Button-RegisterNow')}
          />
        </View>
      )}
    </View>
  );
};

export default OnBoardingExperience;

//The added testIds have the following structure
// OnBoardingExperience-View-Main
// OnBoardingExperience-View-FlatListContainer
// OnBoardingExperience-FlatList-OnBoardingSlideShow
// OnBoardingExperience-View-ButtonsContainer
// OnBoardingExperience-Button-SignIn
// OnBoardingExperience-Button-RegisterNow
